export default "__VITE_ASSET__DcBqvWYN__";